import typeCheck from 'common/util/typeCheck';

export default function makeApplyOverridesFunc(overrides) {
  typeCheck('overrides::Object', overrides);

  return (fields) => {
    typeCheck('fields::Array', fields);
    return fields.map((field) => {
      if (overrides[field.id]) {
        return {
          ...field,
          value: overrides[field.id],
        };
      }
      return field;
    });
  };
}
